const validate = {
    /**
     * 脚本表单校验
     */
    status: true,
    /**
     * 固定电话号码和手机号码验证，允许输入格式样例如下
     * [固话格式]：0931-7577654(12) 区号可选，最后的分机号可选
     * [手机格式]：13、14、15、17、18、19开头的手机号，支持手机号前加0
     */
    TelAndMobile(val, field) {
        return /(^[0-9]{3,4}\-[0-9]{7,8}(\(\d{1,6}\))?$)|(^[0-9]{7,8}(\(\d{1,6}\))?$)|(^\([0-9]{3,4}\)[0-9]{3,8}(\(\d{1,6}\))?$)|(^0{0,1}1[3|4|5|7|8|9][0-9]{9}$)/.test(val)
    },
    /**
     * 手机号码验证，允许输入格式样例如下
     * [格式]：13、14、15、17、18、19开头的手机号，支持手机号前加0
     */
    Mobile(val, field) {
        return /(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/.test(val)
    },
    /**
     * 身份证号验证
     * [格式]：18位身份证号码
     */
    idNumber(val, field) {
        const aCity = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" }
        let iSum = 0
        if (!/^\d{17}(\d|x)$/i.test(val)) {
            return false
        }
        val = val.replace(/x$/i, "a")
        if (aCity[parseInt(val.substr(0, 2))] == null) {
            return false
        }
        const sBirthday = val.substr(6, 4) + "-" + Number(val.substr(10, 2)) + "-" + Number(val.substr(12, 2))
        const d = new Date(sBirthday.replace(/-/g, "/"))
        if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) {
            return false
        }
        for (let i = 17; i >= 0; i--) {
            iSum += (Math.pow(2, i) % 11) * parseInt(val.charAt(17 - i), 11)
        }
        if (iSum % 11 != 1) {
            return false
        }

        return true
    },
    /**
     * 只允许输入纯文本、符号
     */
    noHtml(val, field) {
        return /^[^<>\/]*$/.test(val)
    },
    /**
     * email校验
     */
    email(val, field) {
        return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(val)
    },
    /**
     * 统一社会信用码校验
     */
     verCode(val, field) {
        return /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(val)
    },
    check() {
        const boxDiv = document.createElement('div')
        boxDiv.className = 'app-error-tip'
        const textDiv = document.createElement('div')
        textDiv.className = 'text'
        boxDiv.appendChild(textDiv)
        const page = document.getElementById('page')
        page.appendChild(boxDiv)

        this.status = true
        const list = document.getElementsByClassName('needCheck')
        for (let i = 0; i < list.length; i++) {
            if (this.status) {
                const validates = eval('(' + list[i].getAttribute('validate') + ')')
                const value = list[i].value
                if (this.status && validates.required) {
                    if (value == '') {
                        this.status = false
                        textDiv.innerText = list[i].getAttribute('placeholder')
                        boxDiv.style.display = 'block'
                        setTimeout(() => {
                            boxDiv.style.display = 'none'
                        }, 1500)
                    }
                }
                if (this.status && validates.TelAndMobile) {
                    if (!this.TelAndMobile(value)) {
                        this.status = false
                        textDiv.innerText = '请填写正确的电话号'
                        boxDiv.style.display = 'block'
                        setTimeout(() => {
                            boxDiv.style.display = 'none'
                        }, 1500)
                    }
                }
                if (this.status && validates.Mobile) {
                    if (!this.Mobile(value)) {
                        this.status = false
                        textDiv.innerText = '请填写正确的手机号'
                        boxDiv.style.display = 'block'
                        setTimeout(() => {
                            boxDiv.style.display = 'none'
                        }, 1500)
                    }
                }
                if (this.status && validates.idNumber) {
                    if (!this.idNumber(value)) {
                        this.status = false
                        textDiv.innerText = '请填写正确的身份证号'
                        boxDiv.style.display = 'block'
                        setTimeout(() => {
                            boxDiv.style.display = 'none'
                        }, 1500)
                    }
                }
                if (this.status && validates.noHtml) {
                    if (!this.noHtml(value)) {
                        this.status = false
                        textDiv.innerText = '请填写正确的内容'
                        boxDiv.style.display = 'block'
                        setTimeout(() => {
                            boxDiv.style.display = 'none'
                        }, 1500)
                    }
                }
                if (this.status && validates.email) {
                    if (!this.email(value)) {
                        this.status = false
                        textDiv.innerText = '请填写正确的email'
                        boxDiv.style.display = 'block'
                        setTimeout(() => {
                            boxDiv.style.display = 'none'
                        }, 1500)
                    }
                }
                if (this.status && validates.verCode) {
                    if (!this.verCode(value)) {
                        this.status = false
                        textDiv.innerText = '请填写正确的统一社会信用码'
                        boxDiv.style.display = 'block'
                        setTimeout(() => {
                            boxDiv.style.display = 'none'
                        }, 1500)
                    }
                }
            }
        }
        return this.status
    }
}

export default validate